import React, { useContext } from 'react';
import { ReactSVG } from 'react-svg'
import { useTheme } from '@mui/material';
import { Context } from '../../states/Store';

/**
 * Permet la colorisation des icônes (SVG uniquement)
 *
 * @param icon : String nom de l'icône
 * @param color : String couleur dans laquelle on souhaite coloriser l'icône, si non complété applique la couleur du theme
 * @param width : String
 * @param height : String
 * @param noTransform {Boolean} : si false n'applique aucune modification de couleur
 * @param svgStyle {Object} : le style appliqué au svg
 * @param wrapperClass : {classes}
 * @returns {Element}
 * @constructor
 */
function EAColorIcon({
  icon,
  color = null,
  width = null,
  height = null,
  noTransform = false,
  svgStyle = null,
  wrapperClass = false,
}) {
  return (
    wrapperClass 
      ? (
        <div className={wrapperClass}>
          <SvgIcon
            icon={icon}
            color={color}
            width={width}
            height={height}
            noTransform={noTransform}
            svgStyle={svgStyle}
          />
        </div>
      ) 
      : (
        <SvgIcon
          icon={icon}
          color={color}
          width={width}
          height={height}
          noTransform={noTransform}
          svgStyle={svgStyle}
        />
      )
  )
}

const SvgIcon = ({
                   icon,
                   color = null,
                   width = null,
                   height = null,
                   noTransform = false,
                   svgStyle = null,
                 }) => {
  const [state] = useContext(Context);
  const theme = useTheme();

  return (
    <ReactSVG
      src={process.env.PUBLIC_URL + '/img/icons/' + icon + '.svg'}
      wrapper={'span'}
      style={svgStyle}
      beforeInjection={(svg) => {
        if (!noTransform) {
          if (color) {
            svg.setAttribute('color', color);
          }
          if (state.personalization.isCustomTemplate && !color) {
            svg.setAttribute('color', theme.palette.primary.primary600);
            svg.setAttribute('fill', theme.palette.primary.primary100);
          }

          if (width) {
            svg.setAttribute('width', width);
          }
          if (height) {
            svg.setAttribute('height', height);
          }
        }
      }}
    />
  );
};

export default EAColorIcon;
